// components/InviteContainer/InviteContainer.tsx
import React from "react";
import { Grid, Box, Stack } from "@mui/material";
import classNames from "classnames";

import { AppConfig } from "../../constants";
import { PublicFooter } from "../PublicFooter";
import useStyles from "./styles";

const linkExpired = require("../../assets/img/link-expired.svg");
const rafiki = require("../../assets/img/rafiki-user-invite.svg");

export interface InviteContainerProps {
  title: string;
  description: React.ReactNode;
  actions: React.ReactNode;
  isExpiredOrInvalid?: boolean;
}

export const InviteContainer: React.FC<InviteContainerProps> = ({
  title,
  description,
  actions,
  isExpiredOrInvalid = false,
}) => {
  const classes = useStyles({
    isExpiredOrInvalidOrRejected: isExpiredOrInvalid,
  });

  return (
    <div className={classes.container}>
      <Grid className={classes.containerGrid} container direction="row">
        <Grid item xs={12} sm={6}>
          <Box className={classes.asideLeft}>
            <div className={classes.sectionAsideLeft}>
              <img
                src={AppConfig.appLogo}
                alt="session-logo"
                data-cy="sessionLogo"
                className={classNames("img-fluid", classes.shipeeziLogo)}
              />

              <div className={classes.containerRafiki}>
                <div className={classes.sectionRafiki}>
                  <img
                    src={isExpiredOrInvalid ? linkExpired : rafiki}
                    className={classes.rafiki}
                    data-cy={isExpiredOrInvalid ? "link-expired" : "rafiki-invite"}
                  />
                </div>
              </div>
            </div>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box
            className={classes.asideRight}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box className={classes.containerAsideRight}>
              <Stack
                className={classes.sectionInvitation}
                justifyContent="center"
                alignItems="flex-start"
                spacing={1}
              >
                <h2 className={classes.title} data-cy="title">
                  {title}
                </h2>

                <Stack width="100%" justifyContent="center" alignItems="flex-start" spacing={1}>
                  {description}
                </Stack>

                <Stack
                  width="100%"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {actions}
                </Stack>
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <PublicFooter />
    </div>
  );
};
